module.exports = __webpack_public_path__ + "assets/fefc1828da2f4d7dd7e6b98f6f0e1091.png";